/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RotorWingEligibleCrewResponse } from '../../models/rotor-wing-eligible-crew-response';

export interface ListRotorWingEligibleCrew$Params {
  base: string;
  dateFrom: string;
  dateTo: string;
}

export function listRotorWingEligibleCrew(http: HttpClient, rootUrl: string, params: ListRotorWingEligibleCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<RotorWingEligibleCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, listRotorWingEligibleCrew.PATH, 'get');
  if (params) {
    rb.query('base', params.base, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RotorWingEligibleCrewResponse>;
    })
  );
}

listRotorWingEligibleCrew.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/eligible-crew';
